import { Button, Flex } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { IConversationMessage } from '@/utils/conversation/types';

export interface INewMessagesNotificationButtonProps {
  scrollToLastReadMessage: (sid: number) => void;
  messages: Array<IConversationMessage>;
  unreadMessages: Array<string>;
}

export const NewMessagesNotificationButton: FC<INewMessagesNotificationButtonProps> = ({
  scrollToLastReadMessage,
  messages,
  unreadMessages,
}) => {
  const { t } = useTranslation();

  const handleNotificationOnClick = () => {
    const index = messages.findIndex((message) => message.sid === unreadMessages[0]) - 1;

    scrollToLastReadMessage(index);
  };

  return unreadMessages.length ? (
    <Flex position="sticky" bottom="calc(100% - 50px)" transform="scaleY(-1)" justifyContent="center">
      <Button
        size="sm"
        maxH="34px"
        opacity={1}
        transition="opacity 0.2s ease-out"
        _disabled={{ opacity: 0 }}
        onClick={handleNotificationOnClick}
      >
        {t('conversation.newMessages')}
      </Button>
    </Flex>
  ) : null;
};
